import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent, LoginComponent, SchoolsComponent } from "./components";
import { AdminGuard } from "./guards";

const routes: Routes = [
  { path: "auth/login", component: LoginComponent },
  {
    path: "", component: HomeComponent, /*canActivate: [AdminGuard],*/
    children: [
      { path: "", redirectTo: "schools", pathMatch: "full", },
      { path: "schools", component: SchoolsComponent },
      { path: "schools/:name", component: SchoolsComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
